/* ==================================================
  お客様からのメッセージ スライダー
===================================================*/

(() => {
  const init = (root) => {
    root.querySelectorAll('[data-store-reviews]').forEach((section) => {
      const list = section.querySelector('[data-store-reviews-list]');
      const scrollbar = section.querySelector('[data-store-reviews-scrollbar]');
      const track = section.querySelector('[data-store-reviews-track]');
      if (!list || !scrollbar || !track || section.dataset.storeReviewsReady) return;
      section.dataset.storeReviewsReady = 'true';

      /* 表示幅に対するトラック幅 */
      const setTrackWidth = () => {
        const ratio = list.scrollWidth > 0 ? (list.clientWidth / list.scrollWidth) * 100 : 100;
        scrollbar.style.setProperty('--track-width', `${Math.max(ratio, 5)}%`);
        scrollbar.classList.toggle('hide', Math.ceil(ratio) >= 100);
      };

      /* スクロール量に応じたトラック位置 */
      const setPosition = () => {
        const max = list.scrollWidth - list.clientWidth;
        let position = max > 0 ? (list.scrollLeft / max) * (scrollbar.clientWidth - track.clientWidth) : 0;
        position = Number.isNaN(position) || position < 0 ? 0 : position;
        scrollbar.style.setProperty('--position', `${Math.round(position)}px`);
      };

      const update = () => {
        setTrackWidth();
        setPosition();
      };

      /* PC時のマウスドラッグスクロール */
      let startX = 0;
      let startScroll = 0;
      let isDragging = false;

      list.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (list.scrollWidth <= list.clientWidth) return;
        isDragging = true;
        startX = event.clientX;
        startScroll = list.scrollLeft;
        list.classList.add('is-dragging');
        list.setPointerCapture(event.pointerId);
      });

      list.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        list.scrollLeft = startScroll - (event.clientX - startX);
      });

      const endDrag = (event) => {
        if (!isDragging) return;
        isDragging = false;
        list.releasePointerCapture(event.pointerId);

        /* 最寄りのカードへスナップ */
        const items = [...list.children];
        const listLeft = list.getBoundingClientRect().left;
        const target = items.reduce((nearest, item) => {
          const offset = Math.abs(item.getBoundingClientRect().left - listLeft);
          return offset < nearest.offset ? { item, offset } : nearest;
        }, { item: null, offset: Infinity }).item;

        list.classList.remove('is-dragging');
        if (target) {
          list.scrollTo({ left: list.scrollLeft + target.getBoundingClientRect().left - listLeft, behavior: 'smooth' });
        }
      };

      list.addEventListener('pointerup', endDrag);
      list.addEventListener('pointercancel', endDrag);

      list.addEventListener('scroll', setPosition, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  /* テーマエディタでの再読み込み */
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
